/** Read-only offsets / credits strip. No new math. */
import React from 'react';
import FinancialValue from '../shared/FinancialValue';
import { OffsetRow } from './pickComputedSurfaces';

function asNumber(v: number | string | undefined): number | undefined {
  if (v === undefined || v === null || v === '') return undefined;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : undefined;
}

export default function OffsetsStrip({ rows }: { rows: OffsetRow[] }) {
  if (!rows.length) return null;
  return (
    <section className="rounded-md border border-[var(--color-border)] bg-[var(--color-bg-surface)] mb-6">
      <header className="px-5 h-12 flex items-center">
        <h2 className="text-[11px] font-medium uppercase tracking-[0.08em] text-[var(--color-text-muted)]">
          Offsets and credits
        </h2>
      </header>
      <dl className="border-t border-[var(--color-border)]">
        {rows.map((r) => (
          <div
            key={r.key}
            className="grid grid-cols-[minmax(0,1fr)_auto_150px] gap-6 px-5 h-11 items-baseline border-t border-[var(--color-hairline)]"
          >
            <dt className="text-[13px] text-[var(--color-text-secondary)]">{r.label}</dt>
            <dd className="font-mono text-[11px] text-[var(--color-text-muted)]">{r.source}</dd>
            <dd className="text-right">
              <FinancialValue value={asNumber(r.amount)} contra />
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
